import { render, staticRenderFns } from "./laboratory.vue?vue&type=template&id=004be3b2&scoped=true&"
import script from "./laboratory.vue?vue&type=script&lang=js&"
export * from "./laboratory.vue?vue&type=script&lang=js&"
import style0 from "./laboratory.vue?vue&type=style&index=0&id=004be3b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004be3b2",
  null
  
)

export default component.exports